<template>
  <div class="container-fluid completed-entries">
    <!-- LIST HEADINGS -->
    <div class="d-flex">
      <div @click="getAllEntries()">
        <base-icon
          name="hash"
          stroke="rgba(100,100,100,1)"
          class="badge badge-pill badge-secondary"
          :class="{'badge-dark': !this.$cookie.get('filterEntries')}"
          width="16"
          height="16"
        >{{this.$cookie.get('entryCount')}}</base-icon>
      </div>
      <div class="flex-grow-1"></div>
      <div @click="getComment()" class="ml-2">
        <base-icon
          name="message-square"
          stroke="rgba(100,100,100,1)"
          class="badge badge-pill badge-secondary"
          :class="{'badge-dark': this.$cookie.get('filterEntries')=='comment'}"
          width="16"
          height="16"
        >{{commentCount}}</base-icon>
      </div>
      <div @click="getFilteredEntries('flag')" class="ml-2">
        <base-icon
          name="flag"
          stroke="rgba(100,100,100,1)"
          class="badge badge-pill badge-secondary"
          :class="{'badge-dark': this.$cookie.get('filterEntries')=='flag'}"
          width="16"
          height="16"
        >{{filteredCounts('flag', true)}}</base-icon>
      </div>
      <div @click="getFilteredEntries('review')" class="ml-2">
        <base-icon
          name="award"
          stroke="rgba(100,100,100,1)"
          class="badge badge-pill badge-secondary"
          :class="{'badge-dark': this.$cookie.get('filterEntries')=='review'}"
          width="16"
          height="16"
        >{{filteredCounts('review', true)}}</base-icon>
      </div>
      <div @click="getNotReviewed()" class="ml-2">
        <base-icon
          name="minus"
          stroke="rgba(100,100,100,1)"
          class="badge badge-pill badge-secondary"
          :class="{'badge-dark': this.$cookie.get('filterEntries')=='not'}"
          width="16"
          height="16"
        >{{filteredCounts('review', false)}}</base-icon>
      </div>
    </div>

    <!-- LIST -->
    <div v-for="(entry, key, index)  in entries" :key="index">
      <div v-if="entry.name">
        <router-link
          :to="{ name: 'completed-entry', params: { ceid: key, entry: entry, index: index} }"
          tag="h3"
        >
          <span class="title">{{entry.entry.title | capitalize}}</span> by
          <span class="photographer">{{entry.name.toLowerCase() }}</span>
        </router-link>

        <div class="d-flex">
          <div class="flex-grow-1">
            <review-entry-meta :entry="entry"/>
          </div>
          <div class="p-2 text-nowrap review-controls">
            <span @click="updateEntry('flag', !entry.flag, key)">
              <base-icon name="flag" class="btn" :class="{ 'btn-danger' : entry.flag }">flag</base-icon>
            </span>
            <span @click="updateEntry('review', !entry.review, key)" class="pl-1">
              <base-icon name="award" class="btn" :class="{'btn-success' : entry.review }">review</base-icon>
            </span>
          </div>
        </div>

        <review-gallery-strip :photos="entry.entry.photos"/>
      </div>
    </div>
    <!-- entrant in entrants -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ReviewGalleryStrip from '@/components/review/ReviewGalleryStrip.vue'
import ReviewEntryMeta from '@/components/review/ReviewEntryMeta.vue'
export default {
  components: { ReviewGalleryStrip, ReviewEntryMeta },
  computed: {
    ...mapState({
      // entrants: state => state.admin.entrands
      entries: state => state.review.entries
    }),
    ...mapGetters({
      // entries: 'review/filteredEntries',
      entryCount: 'review/entryCount',
      filteredCounts: 'review/filteredEntries',
      commentCount: 'review/commentCount'
    })
  },
  methods: {
    updateEntry(key, value, entryID) {
      const payload = {
        key: key,
        value: value,
        doc: entryID
      }
      console.log('key: ' + key, 'value: ' + value, 'doc: ' + entryID)
      this.$store.dispatch('review/updateEntry', payload)
    },
    getAllEntries() {
      this.$store.dispatch('review/getEntries')
    },
    getFilteredEntries(filter) {
      this.$cookie.set('filterEntries', filter, 1)
      this.$store.dispatch('review/getFilteredEntries')
    },
    getNotReviewed() {
      this.$cookie.set('filterEntries', 'not', 1)
      this.$store.dispatch('review/getNotReviewed')
    },
    getComment() {
      this.$cookie.set('filterEntries', 'comment', 1)
      this.$store.dispatch('review/getComment')
    }
    /*,
    setFilterCookie(filter) {
      if (filter === 'all') {
        this.$cookie.delete('filterEntries')
      } else {
        this.$cookie.set('filterEntries', filter, 1)
      }
      console.log('Cookie: ' + this.$cookie.get('filterEntries'))
    }*/
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  mounted() {
    // this.getters.filteredEntries('period', '2016')
  }
}
</script>

<style lang="scss">
.completed-entries {
  .badge {
    cursor: pointer;
  }
  .badge.badge-secondary {
    background-color: #969696;
  }
  .badge.badge-secondary.badge-dark {
    background-color: #000000;
  }
  .badge .icon {
    stroke: rgba(255, 255, 255, 1);
  }
  h3 {
    font-weight: 300;
    margin-top: 1em;
    font-size: 1.8rem;
    cursor: pointer;
    .title {
      text-transform: capitalize;
    }
    .photographer {
      text-transform: capitalize;
    }
  }
  .btn-danger .icon,
  .btn-success .icon {
    stroke: rgba(255, 255, 255, 1);
  }
}
</style>
